/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S4_I5Inputs */

const tr_kullanim_s4_i5 = /** @type {(inputs: Kullanim_S4_I5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryeri API anahtarları ve ticari verilerinizden Kullanıcı veri sorumlusu sıfatıyla sorumludur.`)
};

const en_kullanim_s4_i5 = /** @type {(inputs: Kullanim_S4_I5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The User is responsible for the marketplace API keys and your commercial data in the capacity of data controller.`)
};

const de_kullanim_s4_i5 = /** @type {(inputs: Kullanim_S4_I5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Marktplatz-API-Schlüssel und Ihre Geschäftsdaten ist der Nutzer in der Eigenschaft als Verantwortlicher verantwortlich.`)
};

const ru_kullanim_s4_i5 = /** @type {(inputs: Kullanim_S4_I5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За API-ключи маркетплейсов и ваши коммерческие данные Пользователь отвечает в качестве оператора данных.`)
};

/**
* | output |
* | --- |
* | "The User is responsible for the marketplace API keys and your commercial data in the capacity of data controller." |
*
* @param {Kullanim_S4_I5Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s4_i5 = /** @type {((inputs?: Kullanim_S4_I5Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S4_I5Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s4_i5(inputs)
	if (locale === "de") return de_kullanim_s4_i5(inputs)
	if (locale === "ru") return ru_kullanim_s4_i5(inputs)
	return tr_kullanim_s4_i5(inputs)
});